(function () {
  var root = document.querySelector('.protein-order');
  if (!root) return;
  var started = false;
  function boot() {
    if (started) return;
    started = true;
    (function () {
        document.querySelectorAll('.protein-order-card').forEach(function (card) {
          var qtyInput = card.querySelector('.protein-order-qty__input');
          card.querySelectorAll('[data-qty-delta]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var delta = parseInt(btn.dataset.qtyDelta, 10);
              var next = Math.max(1, parseInt(qtyInput.value, 10) + delta);
              qtyInput.value = next;
            });
          });
    
          var form = card.querySelector('[data-card-form]');
          var sellingPlanSelect = card.querySelector('[data-selling-plan-input]');
          var purchaseRadios = card.querySelectorAll('[data-purchase-option]');
    
          function syncPurchaseMode() {
            var checked = card.querySelector('[data-purchase-option]:checked');
            var mode = checked ? checked.value : 'subscribe';
            if (form) form.setAttribute('data-purchase', mode);
            if (sellingPlanSelect) sellingPlanSelect.disabled = mode !== 'subscribe';
          }
    
          if (purchaseRadios.length) {
            purchaseRadios.forEach(function (radio) {
              radio.addEventListener('change', syncPurchaseMode);
            });
            syncPurchaseMode();
          }
        });
    
        // Quick-buy sheet open/close
        var lastFocus = null;
        function openSheet(sheet, opener) {
          if (!sheet) return;
          lastFocus = opener || document.activeElement;
          sheet.hidden = false;
          sheet.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          var firstFocus = sheet.querySelector('.quickbuy-sheet__close');
          if (firstFocus) firstFocus.focus();
        }
        function closeSheet(sheet) {
          if (!sheet || sheet.hidden) return;
          sheet.hidden = true;
          sheet.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        }
        document.querySelectorAll('[data-quickbuy-open]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var id = btn.getAttribute('data-quickbuy-open');
            openSheet(document.getElementById('quickbuy-' + id), btn);
          });
        });
        document.querySelectorAll('[data-quickbuy-close]').forEach(function (el) {
          el.addEventListener('click', function () {
            closeSheet(el.closest('.quickbuy-sheet'));
          });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          document.querySelectorAll('.quickbuy-sheet:not([hidden])').forEach(closeSheet);
        });
    
        document.querySelectorAll('[data-flavor-carousel]').forEach(function (root) {
          var track = root.querySelector('[data-flavor-track]');
          var prev = root.querySelector('[data-flavor-prev]');
          var next = root.querySelector('[data-flavor-next]');
          var section = root.closest('.protein-order');
          var tabs = section ? section.querySelectorAll('[data-product-tab]') : [];
          if (!track) return;
    
          function visibleCards() {
            return Array.from(track.querySelectorAll('.protein-order-card:not([hidden])'));
          }
    
          function visibleDots() {
            return Array.from(root.querySelectorAll('[data-flavor-dot]:not([hidden])'));
          }
    
          function cardStep() {
            var card = visibleCards()[0];
            if (!card) return track.clientWidth;
            var styles = window.getComputedStyle(track);
            var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
            return card.getBoundingClientRect().width + gap;
          }
    
          function activeIndex() {
            var step = cardStep();
            if (!step) return 0;
            return Math.round(track.scrollLeft / step);
          }
    
          function update() {
            var idx = activeIndex();
            var maxScroll = track.scrollWidth - track.clientWidth - 1;
            if (prev) prev.disabled = track.scrollLeft <= 0;
            if (next) next.disabled = track.scrollLeft >= maxScroll;
            visibleDots().forEach(function (d, i) {
              if (i === idx) d.classList.add('is-active'); else d.classList.remove('is-active');
            });
          }
    
          function selectFormat(format) {
            tabs.forEach(function (tab) {
              var selected = tab.getAttribute('data-product-tab') === format;
              tab.classList.toggle('is-active', selected);
              tab.setAttribute('aria-selected', selected ? 'true' : 'false');
            });
            track.querySelectorAll('[data-product-format]').forEach(function (card) {
              card.hidden = card.getAttribute('data-product-format') !== format;
            });
            root.querySelectorAll('[data-dot-format]').forEach(function (dot) {
              dot.hidden = dot.getAttribute('data-dot-format') !== format;
              dot.classList.remove('is-active');
            });
            if (section) {
              section.querySelectorAll('[data-format-media]').forEach(function (panel) {
                panel.hidden = panel.getAttribute('data-format-media') !== format;
              });
              section.querySelectorAll('[data-format-claims]').forEach(function (claims) {
                claims.hidden = claims.getAttribute('data-format-claims') !== format;
              });
              var formatVideo = section.querySelector('[data-format-video]');
              if (formatVideo) {
                var mobileProductLayout = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
                if (format === 'squares' && !mobileProductLayout) {
                  formatVideo.preload = 'metadata';
                  formatVideo.load();
                  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                  if (!reduceMotion) {
                    var played = formatVideo.play();
                    if (played && played.catch) played.catch(function () {});
                  }
                } else {
                  formatVideo.pause();
                }
              }
            }
            var firstDot = visibleDots()[0];
            if (firstDot) firstDot.classList.add('is-active');
            track.scrollLeft = 0;
            window.requestAnimationFrame(update);
          }
    
          tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
              selectFormat(tab.getAttribute('data-product-tab'));
            });
          });
    
          if (prev) prev.addEventListener('click', function () {
            track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
          });
          if (next) next.addEventListener('click', function () {
            track.scrollBy({ left: cardStep(), behavior: 'smooth' });
          });
          track.addEventListener('scroll', function () {
            window.requestAnimationFrame(update);
          });
          window.addEventListener('resize', update);
          selectFormat('cookies');
          update();
        });
      })();
    
    /* Desktop hover-image loader (2026-08 page-weight repair).
         Cards ship their hover image as `data-hover-src`; we only promote it to a real
         `src` on devices that support hover, and only once the pointer actually enters
         the card. Touch devices never download it. Fully optional: if this script does
         not run, the card simply never shows its hover state. */
      (function () {
        if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        document.querySelectorAll('.protein-order-card--has-hover').forEach(function (card) {
          var img = card.querySelector('[data-hover-src]');
          if (!img) return;
          var load = function () {
            card.removeEventListener('pointerenter', load);
            card.removeEventListener('focusin', load);
            if (img.dataset.hoverSrcset) img.srcset = img.dataset.hoverSrcset;
            if (img.dataset.hoverSizes) img.sizes = img.dataset.hoverSizes;
            img.src = img.dataset.hoverSrc;
            img.removeAttribute('data-hover-src');
          };
          card.addEventListener('pointerenter', load, { once: true });
          card.addEventListener('focusin', load, { once: true });
        });
      })();
  }
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        observer.disconnect();
        boot();
      }
    }, { rootMargin: '600px 0px' });
    observer.observe(root);
    root.addEventListener('focusin', boot, { once: true });
    root.addEventListener('pointerenter', boot, { once: true });
  } else {
    boot();
  }
})();
